import React, { memo, useEffect } from "react";
import { ArrowRight } from "lucide-react";

const FooterCta = ({ title, subtitle }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;

    script.onload = () => {
      console.log("✅ Calendly script loaded");
    };

    script.onerror = () => {
      console.error("❌ Failed to load Calendly script");
    };

    document.body.appendChild(script);

    const handleEvent = (e) => {
      if (e?.data?.event === "calendly.event_scheduled") {
        console.log("✅ Meeting Scheduled:", e.data);
      }
    };

    window.addEventListener("message", handleEvent);
    return () => window.removeEventListener("message", handleEvent);
  }, []);

  // ✅ Popup handler with fallback retry
  const handleBookDemo = () => {
    console.log("👆 Book Demo clicked");

    const openPopup = () => {
      if (window.Calendly?.initPopupWidget) {
        window.Calendly.initPopupWidget({
          url: "https://calendly.com/triosoft-support/30min",
        });
        console.log("✅ Calendly Popup Opened");
        return true;
      }
      return false;
    };

    // ✅ Try opening immediately
    if (openPopup()) return;

    // ✅ Retry after delay if script isn't ready
    console.warn("⚠️ Calendly not ready, retrying...");
    setTimeout(() => {
      if (!openPopup()) {
        alert("Calendly is still loading. Please try again in a moment.");
      }
    }, 500);
  };
  return (
    <section className="py-10 lg:py-20 bg-[var(--dark-blue)]">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 text-center">
        <h2 className="font-heading text-3xl lg:text-4xl font-bold mb-6 text-[var(--white)] popingFont">
          {title}
        </h2>
        <p className="text-[var(--white)] text-lg mb-8 max-w-2xl mx-auto">
          {subtitle}
        </p>

        <button className="second_theme_btn2" onClick={handleBookDemo}>
          Book Demo
          <ArrowRight className="ml-2 h-5 w-5" />
        </button>
      </div>
    </section>
  );
};
export default memo(FooterCta);
